import React from "react";

const EmptyTableRow = ({ colSpan = 1, text = "No data found" }) => (
  <tr className="empty-table-row">
    <td colSpan={colSpan} className="empty-table-cell">
      {text}
    </td>
  </tr>
);

export default EmptyTableRow;
